import { s } from '@/theme/tokens';
import { tableV2BodyRowHeightPx } from './TableV2Constants';
import type { SxProps, Theme } from '@/ui/primitives';

export const tableV2NameCellContentSx = {
  alignItems: 'center',
  display: 'flex',
  minHeight: `calc(${String(tableV2BodyRowHeightPx)}px - ${s('md')} - ${s('md')})`,
  minWidth: 0,
  overflow: 'hidden',
} satisfies SxProps<Theme>;

export const tableV2SingleLineNameStackSx = {
  transform: 'translateY(2px)',
} satisfies SxProps<Theme>;

export const tableV2TwoLineNameStackSx = {
  transform: 'translateY(2px)',
} satisfies SxProps<Theme>;
